intra_module.controller('MessageCtrl', function($scope, User, Message, ErrorThrower, identity) {
    $scope.me                   = identity;
    $scope.message.karma_police = false;
    $scope.message.bypass_karma = false;
    const errorManager                = new ErrorThrower;

    $scope.getAuthor = function() {
        if ($scope.message.author != null) { return; }
        User
			.getById({id: $scope.message.user})
			.$promise
			.then(user => $scope.message.author = user);
    };

    $scope.markAsRead = function() {
        $scope.$emit('message:read', $scope.message);
        return Message
        .view({
            conversation_id: $scope.conversation.id,
            message_id:      $scope.message.id}).$promise
        .catch(error => errorManager.minor(error.statusText));
    };

    $scope.bypassKarma = () => $scope.message.bypass_karma = true;

    $scope.message.viewed  = 0 !== $scope.message.views.filter(view => $scope.me.id === view.user).length;
    $scope.getAuthor();
});
